module.exports = __webpack_public_path__ + "static/media/Hus.b79c21b6.PNG";